var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7339 21.3705H19.2047L9.21874 8.3145H10.8612L20.7339 21.3705Z",
    fill: "#b6b6b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0367 0.743182C25.7384 1.41648 28.5832 4.26136 29.2564 6.96307C29.7317 9.52888 29.9804 12.1315 29.9996 14.7409C30.0114 17.524 29.7626 20.302 29.2564 23.0386C28.5832 25.7472 25.7452 28.5869 23.0367 29.2585C21.1355 29.607 19.2141 29.8347 17.284 29.9403C16.5227 29.9801 15.7614 30 15 30C12.3042 29.9952 9.61431 29.7465 6.96331 29.2568C4.26168 28.5852 1.41858 25.7386 0.7453 23.0369C-0.248433 17.7251 -0.248433 12.2749 0.7453 6.96307C1.41858 4.26136 4.26168 1.41648 6.96331 0.743182C9.61431 0.253547 12.3042 0.00480591 15 0C17.6959 0.00463799 20.3857 0.253381 23.0367 0.743182ZM22.9359 6.75H20.1744L15.6251 11.9482L11.6944 6.75H5.99983L12.8014 15.648L6.35157 23.0212H9.1175L14.0929 17.334L18.4457 23.0212H23.9993L16.9045 13.6417L22.9359 6.75Z",
    fill: "#b6b6b6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bbd2ae8a5b26cf2dea192e6ae4de16e4.svg";
export { ForwardRef as ReactComponent };